<template>
<div style="height:100%;" >
     <!-- <div  style="width: 100%;background-color: rgb(34, 34, 34);height:54px;">
        <span data-v-3c6d3300="" style="margin-left: 20px; float: left;">
            <img data-v-3c6d3300="" src="../assets/img/MKD-logo.png" style="max-height: 50px;cursor:pointer;" @click="toOurWeb()">
          
        </span>
    </div> -->
       <!-- <div style="width:70%;margin:auto;font-size: 1.17em;padding-top:50px;">
        
            <p>Dear Customers,</p> 
            Due to a very high demand to access to our platform, 
            We are sorry to inform you that new requests to access to our service for customers with less than 30 orders per day are currently closed. 
            We are sorry for the inconvenience.
            We're currently creating a new system to allow sellers with less than 30 orders per day to use our service, 
            It should be ready in 2 or 3 months.
            <p>Thank you for your understanding</p>
            <P style="text-align:right;margin-right:170px;">SR Team</P> 
        </div> -->
        <div style="display:flex;    min-height: 100%;">
            <div class="Shopifylogin-container" style="width:35%;">
              

   
                <div class="shopifyLogin">
                  <img src="../assets/img/shopifyMKDlogo.png" alt="" width="45%">
                </div>
                <div class="bottom-content">
                  <div class="bottom-content-title">
                    Dropshipping Agency
                  </div>
                  
                  <div class="text-content">
                    <p>It has never been easier to start your own</p>
                    <p>dropshipping business with Shipping Revolution.</p>
                    <br>
                    <p>Shipping Revolution lets you find products on the</p>
                    <p>world's most popular marketplaces, add them to</p>
                    <p>your e-commerce store, and ship them directly to</p>
                    <p>your customers.</p>
                  </div>
                  <div class="router-btn" @click="toCustomerLogin()">
                    Get Started
                  </div>
                </div>
        </div>
             <div style="width:65%;">
            <div :style="login_cm_bj" class="customer-left-bg">
                <div class="login-opactiy"></div>
            
            </div>
        </div>
       
        </div>





        <!-- 注册弹窗 -->
        <el-dialog :visible.sync="showRegisterDialog" class="Register-dialog-wrapper"  :modal-append-to-body="true" :append-to-body="true" width="30%" title="Register">
           
          
          
            
             <!-- <register /> -->

        </el-dialog>


</div>
</template>
<!--
<template>
    <div>
        <el-select v-model="loginPage.Value" @change="LenChange()">
            <el-option v-for="item in ls" :value="item.Value" :label=" item.Text"></el-option>
        </el-select>
        <div class="container-fluid">
            <div style="margin: 100px auto; width: 500px;">
                <form role="form">
                    <form-group :placeholder="gets('$输入{登录名}')" :j="{rex:'w',tips:'登录名为必填'}" v-model="loginPage.LoginName.value" :error="loginPage.LoginName.error" :labelName="gets('$登录名')"></form-group>
                    <form-group :placeholder="gets('$输入{密码}')" :j="{rex:'w',tips:'密码为必填'}" :error="loginPage.Password.error" v-model="loginPage.Password.value" :labelName="gets('$密码')"></form-group>
                    <el-button @click="login()" class="btn btn-default">{{gets('$登录')}}</el-button>
                </form>
            </div>
        </div>
    </div>
</template>
-->
<script>
import { userRequest as UserRequest } from '@/request/user'
    import SIdentify  from '../components/verificationCode'
    import {
        languageRequest
    } from '../request/language'
    import {
        userRequest
    } from '../request/user.js'
    import {
        ToComponentData,
        CheckByConfig,
        ToSubmitData
    } from '../config/config.js'
    import {
        LoginPage
    } from '@/config/Sys/userConfig.js'
    import gets from '@/model/language'
    import { PublicDataRequest } from '@/request/PublicData'
    //Check() {
    //         ObjectCheck(this.j,this.value)
    //       },
    export default {
        components: { SIdentify },
        data() {
            return {
        
                login_cm_bj: {
                    backgroundImage: "url(" + require("@/assets/img/customerLoginBG.jpg") + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    width: "100%",   
                    height:"100%",
                },
             
            }
        },
        created() {
           
        },
        mounted(){
           
        },
        computed: {
            
        },
        methods: {
            toCustomerLogin(){
              window.open("http://service.shipping-revolution.com/#/Customerlogin");
            }
        }
    }
    
</script>


<style>



    html {
        background-color: #F5F9FD;
        color: #666;
    }

.s-canvas{
    height: 30px !important;
}
.login-container{
width:500px;
margin:auto;
    position: relative;
    margin-top: 0px !important;
    /* margin: 30px 0; */
   
   
    color: black;
}
.Shopifylogin-container{
  background: linear-gradient(90deg, #FEAA11 0%, #FEB313 36%, #FECD18 95%, #FECF18 99%);
}
.shopifyLogin img{
  margin-left: 8%;
  margin-top: 4%;
}
.router-btn{
  margin-top: 15%;
  width: 250px;
  height: 78px;
  line-height: 78px;
  text-align: center;
  border: 1px solid #ccc;
  color: #FFFFFF;
  background-color: #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
font-size: 24px;


color: #FFC317;

}
.bottom-content-title{
  font-weight: bold;
font-size: 48px;
line-height: 55px;
margin-bottom: 15%;
}
.bottom-content{
  font-family: Helvetica;
font-style: normal;
font-weight: 300;
margin-left:8%;
font-size: 22px;
line-height: 8px;

margin-top: 25%;

color: #FFFFFF;
}
 .customer-left-bg   .login-opactiy{
    width:100%;
    height: 100%;
    position: absolute;
    top:0;
    z-index: 0;
    background: #000;
    opacity: 0.3;
      border: 0 solid rgba(120, 130, 140, 0.13);
    border-radius: 5px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}




</style>



// WEBPACK FOOTER //
// ShopifyLogin.vue?4e0436be